import * as React from 'react';
import styles from './style.module.scss';
import ShortcutManager from "@/editor/ShortcutManager";
import { SvgAnnotations } from "@/components/svg-annotations";

interface Props {
    children: React.ReactNode;
    /** Trigger a registered keyboard shortcut by its alias. */
    shortcutAlias?: string;
    /** Alternatively, run a direct action (used for menu-only commands with no shortcut). */
    onSelect?: () => void;
    disabled?: boolean;
}

export const Entry: React.FC<Props> = (props) => {
    const onClick = () => {
        if (props.disabled) {
            return;
        }

        if (props.onSelect) {
            props.onSelect();
        } else {
            const shortcut = ShortcutManager.GetShortcutFromAlias(props.shortcutAlias);
            if (!shortcut) {
                throw Error(`Could not find shortcut definition for shortcut '${props.shortcutAlias}'`);
            }

            shortcut.action(null);
        }

        // Close the popup.
        document.dispatchEvent(new Event("mousedown"));
        SvgAnnotations.UpdateAnnotations();
    }

    return (
        <li>
            <button type="button" onClick={onClick} disabled={props.disabled}>
                {props.children}
                <span className={styles.shortcut}>{props.shortcutAlias ? ShortcutManager.ShortcutAliasToKeyPatternString(props.shortcutAlias, 1) : ""}</span>
            </button>
        </li>
    );
}

